import { AnswerItemType } from 'src/model/card'

const getDrawerImages = (id, selected) => {
  const parentFolder = selected ? 'hovered' : 'default'
  switch (id) {
    case AnswerItemType.INFORM:
      return `/assets/card-type-images/index-${parentFolder}/information-knowledge.svg`
    case AnswerItemType.TESTINGSINGLECHOICE:
      return `/assets/card-type-images/index-${parentFolder}/one-correct-answer.svg`
    case AnswerItemType.TESTINGMULTIPLECHOICE:
      return `/assets/card-type-images/index-${parentFolder}/multiple-correct-answers.svg`
    case AnswerItemType.SURVEYSINGLECHOICE:
      return `/assets/card-type-images/index-${parentFolder}/single-choice.svg`
    case AnswerItemType.SURVEYMULTIPLECHOICE:
      return `/assets/card-type-images/index-${parentFolder}/multiple-choice.svg`
    case AnswerItemType.SURVEYFREEFORM:
      return `/assets/card-type-images/index-${parentFolder}/open-ended.svg`
    case AnswerItemType.SURVEYINPUT:
      return `/assets/card-type-images/index-${parentFolder}/basic-input.svg`
    case AnswerItemType.SURVEYSTARS:
      return `/assets/card-type-images/index-${parentFolder}/star-rating.svg`
    case AnswerItemType.SURVEYNUMERICENTRY:
      return `/assets/card-type-images/index-${parentFolder}/numeric-answer.svg`
    case AnswerItemType.SIGNUP:
      return `/assets/card-type-images/index-${parentFolder}/information-knowledge.svg`
    case AnswerItemType.STRIPEPAYMENT:
      return `/assets/card-type-images/index-${parentFolder}/information-knowledge.svg`
    case AnswerItemType.RESULT:
      return `/assets/card-type-images/index-${parentFolder}/conditional.svg`
    case AnswerItemType.SERTIFIERCARD:
      return `/assets/card-type-images/index-${parentFolder}/information-knowledge.svg`
    case AnswerItemType.SCORECARD:
      return `/assets/card-type-images/index-${parentFolder}/score.svg`
    case AnswerItemType.PROTECTIONCARD:
      return `/assets/card-type-images/index-${parentFolder}/password-card.svg`
    case AnswerItemType.RESULTDEFAULT:
      return `/assets/card-type-images/index-${parentFolder}/congratulations.svg`
    case AnswerItemType.AI:
      return `/assets/card-type-images/index-${parentFolder}/information-knowledge.svg`
    case AnswerItemType.BADGE:
      return `/assets/card-type-images/index-${parentFolder}/badge.svg`
    default:
      return `/assets/card-type-images/index-${parentFolder}/information-knowledge.svg`
  }
}

export { getDrawerImages }
